import React, { useEffect } from "react";
import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import { onboardingConstants } from "../../../../_redux/_constants";
import { ProgressBar } from "../../../_uiComponents/Onboarding/ProgressBar";
import PreferOnboardImage from "../../../../styles/img/onboard/not-customer.png";
import UiRadioInput from "../../../_uiComponents/common/UiRadioInput";
import {
  assignRegistrationType,
  onboardingClearFormResponseData,
  removeFormDataFeilds,
} from "../../../../_redux/_actions/onboarding.actions";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { UiOptionBox } from "../../../_uiComponents/Onboarding/UiOptionBox";

export const RegistrationOption = (props) => {
  const { ownFormData: ownFormData } = useSelector((state) => state.onboarding);
  const { t, i18n } = useTranslation();

  const options = [
    { label: "Savings", value: onboardingConstants.REGISTRATION_OPTION_SAVINGS },
    { label: "Fixed Deposits", value: onboardingConstants.REGISTRATION_OPTION_FIXED_DEPOSITS },
    // { label: "Lending", value: onboardingConstants.REGISTRATION_OPTION_LENDING },
    // { label: "Pawning", value: onboardingConstants.REGISTRATION_OPTION_PAWNING },
  ];

  const [selectedOption, setSelectedOption] = useState(
    ownFormData?.registrationType
      ? ownFormData.registrationType
      : null,
  );

  const [isWarningOpen, setIsWarningOpen] = useState(false);

  const dispatch = useDispatch();

  const submit = (option) => {
    if (option) {
      dispatch(assignRegistrationType({ registrationType: onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT , accountType : option }));
      //     dispatch(removeFormDataFeilds(["cardNo", "pin"]));

      props?.changeFlowStep(
        onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT,
      );
    }
  };

  const OptionSelected = (option) => {
    setSelectedOption(option);
    submit(option);
  };

  useEffect(() => {
    if (ownFormData?.registrationType) {
      props?.setIsFormDirty(true);
    }
  }, [ownFormData]);

  const goBack = () => {
    dispatch(onboardingClearFormResponseData());
    props?.changeFlowStep(onboardingConstants.NIC_PASSPORT_VALIDATION_STEP);
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box df-reg-option-btn-space">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={props?.closeBtn}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <ProgressBar
              noOfActive={1}
              total={
                selectedOption ==
                onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
                  ? 7
                  : 6
              }
            />

            <BackIcon onClick={goBack} />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <h2 className="df-reset-pw-title text-center">
                  {t("Select your preferred option for registering")}
                </h2>

                <img
                  src={PreferOnboardImage}
                  className="df-reset-pw-img df-onboard-side-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <div className="df-options-container">
                  {options.map((option) => (
                    <UiOptionBox
                      key={option.value}
                      label={option.label}
                      value={option.value}
                      selected={selectedOption === option.value}
                      onClick={() => OptionSelected(option.value)}
                    />
                  ))}
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <UiPopup openModal={isWarningOpen}>
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          buttonText={t("Ok")}
          buttonOnClick={() => {
            setIsWarningOpen(false);
            dispatch(removeFormDataFeilds(["accountNumber"]));
            props?.changeFlowStep(
              onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT,
            );
          }}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p className="mb-1">
            {t(
              "Onboard using your LOLC Account requires taking a call to our Call Centre or being physically present at the branch for a safe and secure validation.",
            )}
          </p>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
